import { createAsyncThunk } from '@reduxjs/toolkit'
import { getShareAnalyticDetailsBySlugService } from '../../core/api/services/bookmetrie/get-share-analytic-details-by-slug.service'
import { SHARE_ANALYTIC_DETAILS_GET_ANALYTIC_BY_SLUG_ID_ACTION } from '../prefix-actions.config'
import { AnalyticDetailsInterface } from '../../core/interface/analytics/analytic-details.interface'
import { RootState } from '../store'

export const shareAnalyticDetailsGetShareAnalyticBySlugAction =
  createAsyncThunk(
    SHARE_ANALYTIC_DETAILS_GET_ANALYTIC_BY_SLUG_ID_ACTION,
    async (slug: string, { getState }): Promise<AnalyticDetailsInterface> => {
      try {
        const { analyticDetailsV2State } = getState() as RootState
        const { cancelTokenGetAnalyticDetailsBySlug } = analyticDetailsV2State
        const { data } = await getShareAnalyticDetailsBySlugService(
          slug,
          cancelTokenGetAnalyticDetailsBySlug?.token,
        )

        return data
      } catch (error) {
        throw new Error()
      }
    },
  )
